import snakeize from 'snakeize';

import { PLATFORMS } from 'app/utils/constants';

const { APP_ENV } = process.env;
const __PROD__ = APP_ENV === 'production';

const analyticsLogEvent = (name, params = {}, platform, version, source) => {
  if (!name) {
    return;
  }

  const reducedParams = Object.keys(params).reduce(
    (_params, key) => {
      const value = params[key];

      // big query integer issue fix but ignore ecommerce purchase event
      if (
        typeof value === 'number' &&
        name !== 'ecommerce_purchase' &&
        name !== 'purchase'
      ) {
        return {
          ..._params,
          [key]: value.toString(),
        };
      }

      return {
        ..._params,
        [key]: value,
      };
    },
    source ? { source } : {}
  );

  if (!__PROD__) {
    console.log('%cfirebase', 'color: #20a2ae;', name, reducedParams);
  }

  if (window.AnalyticsWebInterface) {
    // Call Android interface
    window.AnalyticsWebInterface.logEvent(
      name,
      JSON.stringify(snakeize(reducedParams))
    );
  } else if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.chatie
  ) {
    // Call iOS interface
    let command = 'firebaseLogEvent';
    if (platform === PLATFORMS.IOS) {
      command = 'firebase:logEvent';
    }

    const message = {
      command,
      name,
      parameters: snakeize(reducedParams),
    };
    window.webkit.messageHandlers.chatie.postMessage(message);
  }
};

const setAnalyticsUserProperty = (name, value, platform, version) => {
  if (!name || !value) {
    return;
  }

  if (!__PROD__) {
    console.log('%cfirebase user property', 'color: #20a2ae;', name, value);
  }

  if (window.AnalyticsWebInterface) {
    // Call Android interface
    window.AnalyticsWebInterface.setUserProperty(name, value);
  } else if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.chatie
  ) {
    // Call iOS interface
    let command = 'firebaseSetUserProperty';
    if (platform === PLATFORMS.IOS) {
      command = 'firebase:setUserProperty';
    }

    const message = {
      command,
      name,
      value,
    };
    window.webkit.messageHandlers.chatie.postMessage(message);
  }
};

class FirebaseDispatcher {
  constructor(firebaseApp, store, interface_) {
    this.app = firebaseApp;
    this.store = store;
    this.interface = interface_;

    const { platform, version } = this.store.getState().common;

    this.platform = platform;
    this.version = version;
  }

  logEvent = (name, params = {}) => {
    const { source } = this.store.getState().common;

    analyticsLogEvent(name, params, this.platform, this.version, source);
  };

  setUserProperty = (name, value) => {
    setAnalyticsUserProperty(name, value, this.platform, this.version);
  };

  logWebEvent = (key, data = {}) => {
    if (this.platform) {
      return;
    }

    if (!this.app) {
      return;
    }

    if (!__PROD__) {
      console.log('%cfirebase web', 'color: #20a2ae;', key, data);
    }

    this.app.analytics().logEvent(
      key,
      snakeize({
        ...data,
        referrer: document.referrer,
      })
    );
  };
}

export default {
  analyticsLogEvent,
  setAnalyticsUserProperty,
  FirebaseDispatcher,
};



// WEBPACK FOOTER //
// ./src/app/utils/firebase.js